<template>
    <div class="typography-area">
        <div class="container-fluid">
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Default Typography</h3>
                </div>

                <h1>h1. Bootstrap heading</h1>
                <h2>h2. Bootstrap heading</h2>
                <h3>h3. Bootstrap heading</h3>
                <h4>h4. Bootstrap heading</h4>
                <h5>h5. Bootstrap heading</h5>
                <h6>h6. Bootstrap heading</h6>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Color Typography</h3>
                </div>

                <h1 class="text-primary">h1. Bootstrap heading</h1>
                <h2 class="text-secondary">h2. Bootstrap heading</h2>
                <h3 class="text-success">h3. Bootstrap heading</h3>
                <h4 class="text-danger">h4. Bootstrap heading</h4>
                <h5 class="text-warning">h5. Bootstrap heading</h5>
                <h6 class="text-info">h6. Bootstrap heading</h6>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Background Typography</h3>
                </div>

                <h1 class="text-white bg-primary">h1. Bootstrap heading</h1>
                <h2 class="text-white bg-secondary">h2. Bootstrap heading</h2>
                <h3 class="text-white bg-success">h3. Bootstrap heading</h3>
                <h4 class="text-white bg-danger">h4. Bootstrap heading</h4>
                <h5 class="text-white bg-warning">h5. Bootstrap heading</h5>
                <h6 class="text-white bg-info">h6. Bootstrap heading</h6>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Display Typography</h3>
                </div>

                <h1 class="display-1">Display 1</h1>
                <h1 class="display-2">Display 2</h1>
                <h1 class="display-3">Display 3</h1>
                <h1 class="display-4">Display 4</h1>
                <h1 class="display-5">Display 5</h1>
                <h1 class="display-6">Display 6</h1>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Lead Typography</h3>
                </div>

                <p class="lead">
                    This is a lead paragraph. It stands out from regular paragraphs.
                </p>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Inline Text Elements Typography</h3>
                </div>

                <p>You can use the mark tag to <mark>highlight</mark> text.</p>
                <p><del>This line of text is meant to be treated as deleted text.</del></p>
                <p><s>This line of text is meant to be treated as no longer accurate.</s></p>
                <p><ins>This line of text is meant to be treated as an addition to the document.</ins></p>
                <p><u>This line of text will render as underlined.</u></p>
                <p><small>This line of text is meant to be treated as fine print.</small></p>
                <p><strong>This line rendered as bold text.</strong></p>
                <p><em>This line rendered as italicized text.</em></p>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Abbreviations Typography</h3>
                </div>

                <p><abbr title="attribute">attr</abbr></p>
                <p><abbr title="HyperText Markup Language" class="initialism">HTML</abbr></p>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Blockquotes Typography</h3>
                </div>

                <blockquote class="blockquote">
                    <p>A well-known quote, contained in a blockquote element.</p>
                </blockquote>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Naming a Source Typography</h3>
                </div>

                <figure>
                    <blockquote class="blockquote">
                        <p>A well-known quote, contained in a blockquote element.</p>
                    </blockquote>
                    <figcaption class="blockquote-footer">
                        Someone famous in <cite title="Source Title">Source Title</cite>
                    </figcaption>
                </figure>
            </div>
            
            <div class="card-box-style">
                <div class="others-title">
                    <h3>Naming a Source Alignment Left Typography</h3>
                </div>

                <figure class="text-center">
                    <blockquote class="blockquote">
                        <p>A well-known quote, contained in a blockquote element.</p>
                    </blockquote>
                    <figcaption class="blockquote-footer">
                        Someone famous in <cite title="Source Title">Source Title</cite>
                    </figcaption>
                </figure>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>Naming a Source Alignment End Typography</h3>
                </div>

                <figure class="text-end">
                    <blockquote class="blockquote">
                        <p>A well-known quote, contained in a blockquote element.</p>
                    </blockquote>
                    <figcaption class="blockquote-footer">
                        Someone famous in <cite title="Source Title">Source Title</cite>
                    </figcaption>
                </figure>
            </div>

            <div class="card-box-style">
                <div class="others-title">
                    <h3>List Typography</h3>
                </div>

                <ul class="list-unstyled">
                    <li>This is a list.</li>
                    <li>It appears completely unstyled.</li>
                    <li>Structurally, it's still a list.</li>
                    <li>However, this style only applies to immediate child elements.</li>
                    <li>Nested lists:
                        <ul>
                            <li>are unaffected by this style</li>
                            <li>will still show a bullet</li>
                            <li>and have appropriate left margin</li>
                        </ul>
                    </li>
                    <li>This may still come in handy in some situations.</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TypographyContent'
}
</script>